const DEFAULT_EPS = 1e-6;
const SEMAPHORE = Symbol();
const NO_OP = () => {
};
const EVENT_ALL = "*";
const EVENT_ENABLE = "enable";
const EVENT_DISABLE = "disable";
export {
  DEFAULT_EPS,
  EVENT_ALL,
  EVENT_DISABLE,
  EVENT_ENABLE,
  NO_OP,
  SEMAPHORE
};
